// eslint-disable-next-line func-names
export const scriptJs = (function () {
  const doc = document;
  const head = doc.getElementsByTagName('head')[0];
  // const s = 'string';
  const f = false;
  const push = 'push';
  const readyState = 'readyState';
  const onreadystatechange = 'onreadystatechange';
  const list = {};
  const ids = {};
  const delay = {};
  const scripts = {};
  let scriptpath;
  let urlArgs;

  function every(ar, fn) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f;
    return 1;
  }
  function each(ar, fn) {
    every(ar, (el) => {
      fn(el);
      return 1;
    });
  }

  function $script(paths, idOrDone, optDone, useCrossOrigin) {
    // eslint-disable-next-line no-param-reassign
    paths = paths[push] ? paths : [paths];
    const idOrDoneIsDone = idOrDone && idOrDone.call;
    const done = idOrDoneIsDone ? idOrDone : optDone;
    const id = idOrDoneIsDone ? paths.join('') : idOrDone;
    let queue = paths.length;
    function loopFn(item) {
      return item.call ? item() : list[item];
    }
    function callback() {
      // eslint-disable-next-line no-plusplus
      if (!--queue) {
        list[id] = 1;
        // eslint-disable-next-line no-unused-expressions
        done && done();
        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for (const dset in delay) {
          // eslint-disable-next-line no-unused-expressions
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = []);
        }
      }
    }
    setTimeout(() => {
      // eslint-disable-next-line consistent-return
      each(paths, function loading(path, force) {
        if (path === null) return callback();

        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          // eslint-disable-next-line no-param-reassign
          path = (path.indexOf('.js') === -1) ? `${scriptpath + path}.js` : scriptpath + path;
        }

        if (scripts[path]) {
          if (id) ids[id] = 1;
          // eslint-disable-next-line eqeqeq
          return (scripts[path] == 2) ? callback() : setTimeout(() => { loading(path, true); }, 0);
        }

        scripts[path] = 1;
        if (id) ids[id] = 1;
        // eslint-disable-next-line no-use-before-define
        create(path, callback, useCrossOrigin);
      });
    }, 0);
    return $script;
  }

  function create(path, fn, useCrossOrigin) {
    const el = doc.createElement('script');
    let loaded;
    // eslint-disable-next-line no-multi-assign,func-names
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;

      // eslint-disable-next-line no-multi-assign
      el.onload = el[onreadystatechange] = null;
      loaded = 1;
      scripts[path] = 2;
      fn();
    };
    el.async = 1;
    if (useCrossOrigin) {
      el.crossOrigin = 'anonymous';
    }
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild);
  }

  $script.get = create;
  // eslint-disable-next-line func-names
  $script.order = function (scripts2, id, done) {
    (function callback(s) {
      // eslint-disable-next-line no-param-reassign
      s = scripts2.shift();
      // eslint-disable-next-line no-unused-expressions
      !scripts2.length ? $script(s, id, done) : $script(s, callback);
    }());
  };
  // eslint-disable-next-line func-names
  $script.path = function (p) {
    scriptpath = p;
  };
  // eslint-disable-next-line func-names
  $script.urlArgs = function (str) {
    urlArgs = str;
  };
  // eslint-disable-next-line func-names
  $script.ready = function (deps, ready, req) {
    // eslint-disable-next-line no-param-reassign
    deps = deps[push] ? deps : [deps];
    const missing = [];
    // eslint-disable-next-line no-unused-expressions
    !each(deps, (dep) => {
      // eslint-disable-next-line no-unused-expressions
      list[dep] || missing[push](dep);
    }) && every(deps, (dep) => list[dep])
      ? ready() : !(
        // eslint-disable-next-line func-names
        function (key) {
          delay[key] = delay[key] || [];
          delay[key][push](ready);
          // eslint-disable-next-line no-unused-expressions
          req && req(missing);
        }(deps.join('|')));
    return $script;
  };
  // eslint-disable-next-line func-names
  $script.done = function (idOrDone) {
    $script([null], idOrDone);
  };

  return $script;
}());

export function wrapScriptMethodsWithGuard(target, methodsArray) {
  try {
    if (target) {
      methodsArray.forEach((methodName) => {
        const originalMethod = target[methodName];
        if (originalMethod) {
          // eslint-disable-next-line no-param-reassign, func-names
          target[methodName] = function (...args) {
            // eslint-disable-next-line no-useless-catch
            try {
              return originalMethod.call(target, ...args);
            } catch (e) {
              throw e;
            }
          };
        }
      });
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
}
